<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="消息通知"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <div class="myitem">
        <van-cell title="新消息通知">
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #right-icon>
            <van-switch v-model="checked1" size="32px" @change='changeSwich'/>
          </template>
        </van-cell>
        <!-- <van-cell title="声音">
          <template #right-icon>
            <van-switch v-model="checked2" size="32px"/>
          </template>
        </van-cell>

        <van-cell title="振动">
          <template #right-icon>
            <van-switch v-model="checked3" size="32px"/>
          </template>
        </van-cell> -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Switch } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Switch)

export default {
  name: 'noticyPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Switch.name]: Switch
  },
  // activated () {
  //   console.log(1111)
  //   this.getMessageStatus()// 查询消息通知开关状态
  // },
  created () {
    this.getMessageStatus()// 查询消息通知开关状态
    // console.log(this.checked1)
  },
  mounted () { },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    getMessageStatus () {
      this.util.post('/getMessageStatus').then(({ data }) => {
        if (data.code === 200) {
          // console.log('接口查询的开关状态' + data.data.messageStatus)
          // this.$root.messageStatus = data.data.messageStatus
          this.messageStatus = data.data.messageStatus
          // localStorage.setItem('messageStatus', data.data.messageStatus) // 存储消息通知状态 0关 1开
          if (this.messageStatus === 1) {
            // console.log('开')
            this.checked1 = true
          } else {
            // console.log('关')
            this.checked1 = false
          }
        } else {
          return Promise.reject(new Error(data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    changeSwich () {
      if (this.checked1) {
        this.messageStatus = 1// 开
        // this.$root.messageStatus = 1
      } else {
        this.messageStatus = 0// 关
        // this.$root.messageStatus = 0
      }
      // 消息通知设置接口
      // console.log(this.messageStatus)
      this.util.post('/updateMessageStatus', {
        messageStatus: this.messageStatus// 消息通知状态 0关 1开
      }).then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
          this.util.toast(data.msg)
          // console.log(this.messageStatus)
          // localStorage.setItem('messageStatus', this.messageStatus) // 存储消息通知状态 0关 1开
          // location.reload()// 刷新页面
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    // this.timer = setInterval(() => {
    //   this.showNotify()
    // }, 50000)
    }

  },
  computed: {},
  data () {
    return {
      messageStatus: '', // 消息通知状态 0关 1开
      checked1: '',
      pageHeight: window.innerHeight
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}
/deep/.van-cell__title{
  line-height: 34px;
}

</style>
